import Login from '@/core/pages/auth/Login/Login';

export default Login;
